(function () {
    "use strict";

    Components.CalendlyRedirect = {
        controller: "CalendlyRedirectController",
        name: "hbCalendlyRedirect",
        templateUrl:
            "angular/app/modules/core/features/calendly/calendly_redirect_page_template.html",
    };
})();
